import { getCarModelOptions } from '@/api/quote'
const SET_ALL_QUOTE = 'SET_ALL_QUOTE'
const SET_QUOTE_FORM = 'SET_QUOTE_FORM'
const SET_CAR_MODEL = 'SET_CAR_MODEL'
const SET_CAR_MODEL_LIMIT = 'SET_CAR_MODEL_LIMIT'
const SET_QUOTE_INFORMATION_FORM = 'SET_QUOTE_INFORMATION_FORM'
const SET_QUOTE_RESULT = 'SET_QUOTE_RESULT'
const SET_IS_BACK = 'SET_IS_BACK'
const SET_CODE = 'SET_CODE'
const SET_COPY_QUOTE_FORM = 'SET_COPY_QUOTE_FORM'

const state = {
  allQuote: null,
  quoteForm: null,
  carModelOptions: null,
  carModelLimit: null,
  quoteInformationForm: null,
  quoteResult: null,
  isBack:null,
  code:null,
  copyQuoteForm:null
}


const mutations = {
  [SET_IS_BACK]: (state, value) => {
    state.isBack= value
  },
  [SET_CODE]: (state, value) => {
    state.code= value
  },
  [SET_ALL_QUOTE]: (state, value) => {
    state.allQuote= value
  },
  [SET_QUOTE_FORM]: (state, value) => {
    state.quoteForm= value
  },
  [SET_COPY_QUOTE_FORM]: (state, value) => {
    state.copyQuoteForm= value
  },
  [SET_CAR_MODEL]: (state, value) => {
    state.carModelOptions= value
  },
  [SET_QUOTE_INFORMATION_FORM]: (state, value) => {
    state.quoteInformationForm= value
  },
  [SET_CAR_MODEL_LIMIT]: (state, value) => {
    state.carModelLimit = value
  },
  [SET_QUOTE_RESULT]: (state, value) => {
    state.quoteResult= value
  },
}

const limit = {
  time: '',
  value: ''
}

const actions = {
  setIsBack({ commit },val){
    commit(SET_IS_BACK, val)
  },
  setCode({ commit },val){
    commit(SET_CODE, val)
  },
  setAllQuote({ commit }, val) {
    commit(SET_ALL_QUOTE, val)
  },
  setQuoteForm({ commit }, val) {
    commit(SET_QUOTE_FORM, val)
  },
  setCopyQuoteForm({ commit }, val) {
    commit(SET_COPY_QUOTE_FORM, val)
  },
  setQuoteResult({ commit }, val) {
    commit(SET_QUOTE_RESULT, val)
  },
  setQuoteInformationForm({ commit }, val) {
    commit(SET_QUOTE_INFORMATION_FORM, val)
  },
  updateCarModelOptions({ commit }, { val, time }) {
    if(limit.time && limit.value && val == limit.value) {
      // 判斷時間 60s  毫秒
      if(limit.time + 60000 >= time) {
        return
      }
      else {
        limit.time = time
      }
    }
    else {
      limit.time = time
      limit.value = val
    }
    console.log(limit, '===')
    return new Promise((resolve, reject) => {
      getCarModelOptions({
        brand_id: val,
        hideLoading:true
      }).then(res => {
        const { data } = res
        commit(SET_CAR_MODEL, data)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
